export interface WalletPayoutApproval {
    id: number;
    reference: string;
    status: WalletStatus;
    date: Date;
    amount: string;
    hostFullName: string;
    hostEmail: string;
}

export enum WalletStatus {
    toPay = 1,
    readyForWithdrawal,
    processing,
    inReview,
    paid,
    error,
    closed,
    withdrawalRequested
}